import { Avatar, Box, Button, Divider, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import developers from "../../_mock/developer";
import BackButton from "../../components/BackButton";

export default function Developer() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [developer, setDeveloper] = useState({});
  const [showMore, setShowMore] = useState(false);

  useEffect(() => {
    setDeveloper(developers.find((e) => String(e.id) === id));
  }, [id]);

  const formatText = (text) => {
    if (text.length < 300 || showMore)
      return (
        <>
          <Typography>{text}</Typography>
          {showMore && (
            <Typography
              color="primary.main"
              onClick={() => setShowMore(false)}
              sx={{ cursor: "pointer" }}
            >
              less
            </Typography>
          )}
        </>
      );
    return (
      <>
        <Typography>{text.slice(0, 300)}...</Typography>
        <Typography
          color="primary.main"
          onClick={() => setShowMore(true)}
          sx={{ cursor: "pointer" }}
        >
          more
        </Typography>
      </>
    );
  };

  return (
    <Box mx={4}>
      <BackButton />
      <Box bgcolor="white" borderRadius={2}>
        <Stack direction="row" p={4} spacing={2}>
          <Avatar
            sx={{ height: 108, width: 108 }}
            src={developer.img}
            alt={developer.name}
          />
          <div>
            <Typography variant="h5">{developer.name}</Typography>
            <Typography variant="body1">India</Typography>
            <Button variant="outlined" onClick={() => navigate(`/dashboard/specialists/hire/${id}`)}>
              Hire
            </Button>
          </div>
        </Stack>
        <Divider />
        <Box p={4}>
          <Typography variant="h4">{developer.role}</Typography>
          {developer.details && formatText(developer.details)}
        </Box>
      </Box>
    </Box>
  );
}
